import AclModule from '../../../common/acl/const/AclModule';
import { canView } from '../../../common/acl/AclService';
import HttpService from '../../../common/http/HttpService';
import AccessEndpoint from '../const/AccessEndpoint';
import VcomProvider from '../../../VcomProvider';

async function canViewCmms() {
  return canView(AclModule.CMMS);
}

async function hasTicketCmmsAccess(ticketId) {
  const hasCmmsModule = await canViewCmms();
  if (hasCmmsModule === false) {
    return false;
  }

  const hasTicketAccessResponse = await HttpService.post(AccessEndpoint.TICKET, { ticketId });
  return hasTicketAccessResponse.data;
}

async function hasWorkOrderCmmsAccess(workOrderId) {
  const hasCmmsModule = await canViewCmms();
  if (hasCmmsModule === false) {
    return false;
  }

  const hasWorkOrderAccessResponse = await HttpService.post(
    AccessEndpoint.WORK_ORDER,
    { workOrderId },
  );
  return hasWorkOrderAccessResponse.data;
}

async function hasSystemCmms(systemId) {
  const hasCmmsModule = await canViewCmms();
  if (hasCmmsModule === false) {
    return false;
  }

  const hasSystemAccess = await HttpService.post(
    AccessEndpoint.CMMS,
    { systemId },
  );
  return hasSystemAccess.data;
}

async function hasCmms() {
  const hasCmmsModule = await canViewCmms();
  if (hasCmmsModule === false) {
    return false;
  }

  if (VcomProvider.systemId === null) {
    return true;
  }

  return hasSystemCmms(VcomProvider.systemId);
}

const AccessService = {
  hasTicketCmmsAccess,
  hasWorkOrderCmmsAccess,
  hasCmms,
  hasSystemCmms,
};

export default AccessService;
